import { AppRoute } from 'enums/AppRoute';

export const AppRouteWithParams = {
  SignIn: AppRoute.SignIn,
  CreateAccount: AppRoute.CreateAccount,
  AcceptInvite: `${AppRoute.AcceptInvite}/:token`,
  PhoneVerification: AppRoute.PhoneVerification,
  ResetPassword: AppRoute.ResetPassword,
  CreateNewPassword: `${AppRoute.ResetPassword}/:resetPasswordToken`,
  ConfirmEmail: AppRoute.ConfirmEmail,
  DocumentPreview: `${AppRoute.DocumentPreview}/:fileExtension/:fileId/:filename`,
  Application: `${AppRoute.Application}/:applicationDisplayId`,
  Forbidden: AppRoute.Forbidden,
  AdminPasswordRequired: AppRoute.AdminPasswordRequired,
  Home: AppRoute.Home,
  Apply: AppRoute.Apply,
  Start: AppRoute.Start,
};
